import React, { Component } from "react";
import { Header, Sticky, List, Table } from "semantic-ui-react";
import { isMobile } from "react-device-detect";
import { connect } from "react-redux";
import _ from "lodash";
import { stickyNavIndexChanged } from "../../actions/nav";
import { stickyNavInitializeContext } from "../../actions/stickyNavAction";

class StickyNav extends Component {
  constructor(props) {
    super(props);
    const stickyNav = this.props.stickyNav;
    stickyNav.handleContextRef = this.handleContextRef;
    this.props.stickyNavInitializeContext(stickyNav);
    this.state = {
      contextRef: undefined,
    };
  }

  componentDidMount() {
    this.isCompMounted = true;
  }

  componentWillUnmount() {
    this.isCompMounted = false;
  }

  isCompMounted = false;

  handleContextRef = (contextRef) => {
    if (this.isCompMounted) this.setState({ contextRef });
  };

  handleClick = (e, index) => {
    this.props.stickyNavIndexChanged(index);
  };

  renderThisContent() {
    const list = [];
    _.forEach(this.props.stickyNav.navs, (data, index) => {
      const className =
        index % 2 === 1
          ? "div-row-odd-child url-link-activity"
          : "url-link-activity";
      list.push(
        <List.Item
          key={`Sticky_Nav_${index}`}
          onClick={(e) => this.handleClick(e, index)}
          className={`${
            data.display === "Add On Reports"
              ? "report-sub-section-header padding-left-5 padding-top-10 padding-bottom-10"
              : className
          }`}
        >
          {data.display === "Add On Reports" ? (
            <b>
              {`${data.display}${
                data.count !== undefined ? ` [${data.count}]` : ""
              }`}
            </b>
          ) : (
            <span className={"display-cursor"}>
              {`${data.display}${
                data !== undefined && data.count !== undefined
                  ? // ? ` [${data.count}]` removing number count
                    ""
                  : ""
              }${
                data !== undefined && data.secCount !== undefined
                  ? //  ? ` [${data.secCount}]` removing number count
                    ""
                  : ""
              }`}
            </span>
          )}
        </List.Item>
      );
    });

    if (isMobile) {
      return (
        <Table>
          <Table.Row className="report-section-header">
            <Table.Cell>
              <Header className="large-font">Jump To:</Header>
            </Table.Cell>
          </Table.Row>
          <List className={"side-nav-container"}>{list}</List>
        </Table>
      );
    }

    return (
      <Sticky context={this.state.contextRef} active>
        <Table>
          <Table.Body>
            <Table.Row className="report-section-header">
              <Table.Cell>
                <Header className="large-font">Jump To:</Header>
              </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>
                <List className={"side-nav-container"}>{list}</List>
              </Table.Cell>
            </Table.Row>
          </Table.Body>
        </Table>
      </Sticky>
    );
  }

  render() {
    return this.renderThisContent();
  }
}

function mapStateToProps(state) {
  return {
    stickyNav: state.stickyNav,
  };
}

export default connect(mapStateToProps, {
  stickyNavInitializeContext,
  stickyNavIndexChanged,
})(StickyNav);



// WEBPACK FOOTER //
// ./src/components/reports/StickyNav.js